import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@app/shared/components/base/base/base.component';
import { HealthService } from '@app/core/services/health/health.service';
import { Health } from '@app/core/services/health/health.models';

@Component({
  selector: 'app-health',
  templateUrl: './health.component.html',
  styleUrls: ['./health.component.scss']
})
export class HealthComponent extends BaseComponent implements OnInit {

  version: string;

  constructor(
    private healthService: HealthService,
  ) {
    super();
  }

  ngOnInit() {
    this.healthService.getHealth().subscribe((response: Health) => {
      this.version = `API Version ${response.version}`;
    });
  }
}
